export const MIN_PROJECTS_CONTAINER_HEIGHT = 140;
export const MIN_PROJECTS_CONTAINER_HEIGHT_EMPTY_PROJECTS = 300;
